/**
 * Modern Card component with enterprise styling
 */

import React from 'react';
import { clsx } from 'clsx';

export interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
  gradient?: boolean;
  padding?: 'sm' | 'md' | 'lg';
  title?: string;
  subtitle?: string;
  actions?: React.ReactNode;
}

export function Card({ 
  children, 
  className, 
  hover = false,
  gradient = false,
  padding = 'md',
  title,
  subtitle,
  actions,
}: CardProps) {
  const paddingClasses = {
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
  };

  return (
    <div
      className={clsx(
        'bg-white dark:bg-theme-paper rounded-xl border border-theme-border transition-all duration-200 shadow-md',
        'text-gray-900 dark:text-theme-text',
        gradient 
          ? 'bg-gradient-to-br from-white dark:from-theme-paper to-primary-50/30 dark:to-primary-900/10 border-primary-200/50 dark:border-primary-700/50 shadow-lg shadow-primary-100/50'
          : '',
        hover && 'hover:shadow-xl hover:-translate-y-1 cursor-pointer card-hover',
        paddingClasses[padding],
        className
      )}
    >
      {(title || actions) && (
        <div className="flex items-center justify-between mb-4">
          {title && (
            <div>
              <h3 className="text-lg font-semibold text-gray-900 dark:text-theme-text">{title}</h3>
              {subtitle && <p className="text-sm text-gray-600 dark:text-theme-text-secondary mt-1">{subtitle}</p>}
            </div>
          )}
          {!title && actions && <div className="flex-1" />}
          {actions}
        </div>
      )}
      {children}
    </div>
  );
}
